module.exports = __webpack_public_path__ + "static/media/radio.cb042b67.svg";